// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchItemFacetsParams = {
    authToken?: string,
    deployment: string,
    ids: number[],
};

export default {
    fetchItemFacets: ({ authToken, deployment, ids }: FetchItemFacetsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/item-facets' });
            request.send({ ids });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
